import { TertiarynavMenu, TertiarynavMenuItem } from "components/navigation/tertiarynav";
import React from "react";
import { useFeature } from "store/selectors/hooks";

export const AgencySettingsNav: React.FC<unknown> = () => {
    const isFaxEnabled = useFeature("fax");
    const isHomeCareEnabled = useFeature("homeCarePrototype");
    return (
        <TertiarynavMenu>
            <TertiarynavMenuItem to="/settings/agency/general">
                Agency Profile
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/invoices">
                Invoices
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/signwise">
                SignWise
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/tasks">Tasks</TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/hosted-form">
                Hosted Intake Form
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/clients">
                Clients
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/communities">
                Communities
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/referrals">
                Referrals
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/agency/customize/cc">
                Custom Fields
            </TertiarynavMenuItem>
            {isHomeCareEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/home-care">
                    Home Care
                </TertiarynavMenuItem>
            ) : null}
            {isFaxEnabled ? (
                <TertiarynavMenuItem to="/settings/agency/fax">Fax</TertiarynavMenuItem>
            ) : null}
        </TertiarynavMenu>
    );
};
